import { observer } from 'mobx-react-lite';

import { CallActionsPanel } from '@gem/call/CallView/Shared/CallActionsPanel/CallActionsPanel';

import { CompactScreenVideoLayout } from '../Shared/CompactScreenVideoLayout/CompactScreenVideoLayout';
import { SpeakerVideo } from '../Shared/SpeakerVideo/SeakerVideo';
import { useGroupVideoCallPresenter } from './GroupVideoCall.presenter';
import styles from './GroupVideoCall.styles.m.css';
import { GroupVideoCallHeader } from './GroupVideoCallHeader/GroupVideoCallHeader';
import { MembersPanel } from './MembersPanel/MembersPanel';

export const GroupVideoCall = observer(() => {
  const { call } = useGroupVideoCallPresenter();

  return (
    <>
      {!call.viewState.isMembersShown && (
        <div className={styles.container}>
          <GroupVideoCallHeader />
          {call.viewState.isGridLayout ? <CompactScreenVideoLayout /> : <SpeakerVideo />}
          <CallActionsPanel />
        </div>
      )}
      {call.viewState.isMembersShown && (
        <div className={styles.membersPanelContainer}>
          <MembersPanel call={call} />
        </div>
      )}
    </>
  );
});
